
export class Canonicalizer {
  public static getCanonical(currentPath: string, canonicalRules: any[]): string {
    const rule = canonicalRules.find(canonical => 
      currentPath === canonical.path ||
      currentPath.startsWith(canonical.path + '?')
    );
    
    if (rule) {
      return rule.canonical;
    }

    // Règles automatiques de canonicalisation
    let canonicalPath = currentPath;

    // Supprimer les paramètres de tracking
    canonicalPath = canonicalPath.split('?')[0];
    
    // Supprimer le slash final sauf pour la racine
    if (canonicalPath.length > 1 && canonicalPath.endsWith('/')) {
      canonicalPath = canonicalPath.slice(0, -1);
    }

    // Uniformiser la casse
    if (canonicalPath !== canonicalPath.toLowerCase()) {
      canonicalPath = canonicalPath.toLowerCase();
    }

    return canonicalPath;
  }
}
